import {
  MembershipSignupCustomPaymentRequestBody,
  MembershipSignupPaymentMethodRequestBody,
  ProductOrderCheckoutCustomPaymentRequestBody,
  ProductOrderCheckoutPaymentMethodRequestBody,
  ProductOrderInvoiceDTO,
  SessionPackSignupCustomPaymentRequestBody,
  SessionPackSignupPaymentMethodRequestBody,
  SubscriptionInvoiceDTO,
} from "@gymflow/types";
import { AxiosInstance } from "axios";

export type SalesApiType = ReturnType<typeof salesApi>;

const salesApi = (axiosInstance: AxiosInstance, clubId: number) => {
  const clubPrefix = `club/${clubId}/`;

  return {
    productOrderCheckoutPaymentMethod({
      orderKey,
      paymentMethodId,
      userMemberId,
      orderItems,
      promotionCode,
      priceOverride,
      walletAmount,
    }: ProductOrderCheckoutPaymentMethodRequestBody) {
      return axiosInstance.put<ProductOrderInvoiceDTO>(
        `${clubPrefix}product-order-checkout/${orderKey}/payment-method/${paymentMethodId}`,
        {
          userMemberId,
          orderItems,
          promotionCode,
          priceOverride,
          walletAmount,
        },
      );
    },
    productOrderCheckoutCustomPayment({
      orderKey,
      customPaymentCategoryId,
      userMemberId,
      orderItems,
      promotionCode,
      priceOverride,
      walletAmount,
    }: ProductOrderCheckoutCustomPaymentRequestBody) {
      return axiosInstance.put<ProductOrderInvoiceDTO>(
        `${clubPrefix}product-order-checkout/${orderKey}/custom-payment/${customPaymentCategoryId}`,
        {
          userMemberId,
          orderItems,
          promotionCode,
          priceOverride,
          walletAmount,
        },
      );
    },
    membershipSignupPaymentMethod({
      orderKey,
      paymentMethodId,
      userMemberId,
      membershipId,
      startDate,
      promotionCode,
      priceOverride,
      walletAmount,
    }: MembershipSignupPaymentMethodRequestBody) {
      return axiosInstance.put<SubscriptionInvoiceDTO>(
        `${clubPrefix}membership-signup/${orderKey}/payment-method/${paymentMethodId}`,
        {
          userMemberId,
          membershipId,
          startDate,
          promotionCode,
          priceOverride,
          walletAmount,
        },
      );
    },
    membershipSignupCustomPayment({
      orderKey,
      customPaymentCategoryId,
      userMemberId,
      membershipId,
      startDate,
      promotionCode,
      priceOverride,
      walletAmount,
    }: MembershipSignupCustomPaymentRequestBody) {
      return axiosInstance.put<SubscriptionInvoiceDTO>(
        `${clubPrefix}membership-signup/${orderKey}/custom-payment/${customPaymentCategoryId}`,
        {
          userMemberId,
          membershipId,
          startDate,
          promotionCode,
          priceOverride,
          walletAmount,
        },
      );
    },
    sessionPackSignupPaymentMethod({
      orderKey,
      paymentMethodId,
      userMemberId,
      sessionPackId,
      startDate,
      promotionCode,
      priceOverride,
      walletAmount,
    }: SessionPackSignupPaymentMethodRequestBody) {
      return axiosInstance.put<SubscriptionInvoiceDTO>(
        `${clubPrefix}session-pack-signup/${orderKey}/payment-method/${paymentMethodId}`,
        {
          userMemberId,
          sessionPackId,
          startDate,
          promotionCode,
          priceOverride,
          walletAmount,
        },
      );
    },
    sessionPackSignupCustomPayment({
      orderKey,
      customPaymentCategoryId,
      userMemberId,
      sessionPackId,
      startDate,
      promotionCode,
      priceOverride,
      walletAmount,
    }: SessionPackSignupCustomPaymentRequestBody) {
      return axiosInstance.put<SubscriptionInvoiceDTO>(
        `${clubPrefix}session-pack-signup/${orderKey}/custom-payment/${customPaymentCategoryId}`,
        {
          userMemberId,
          sessionPackId,
          startDate,
          promotionCode,
          priceOverride,
          walletAmount,
        },
      );
    },
  };
};

export default salesApi;
